import { matchPath } from 'react-router-dom';
import { History } from 'history';
import {
  ROUTER_ENTITY_TO_ROUTE_PATH_MAP,
  RouterEntityDrawer,
  WILDFIRE_PROGRESSION_MODEL_ROUTE_PATH,
} from '../../../../constants';

/** True when the URL is an exact router entity drawer route. */
const pathnameIsExactRouterEntityDrawerPath = (pathname: string): boolean =>
  (Object.keys(ROUTER_ENTITY_TO_ROUTE_PATH_MAP) as RouterEntityDrawer[]).some(
    (key) =>
      matchPath(pathname, {
        path: ROUTER_ENTITY_TO_ROUTE_PATH_MAP[key],
        exact: true,
      }),
  );

const isWildfireProgressionModelPath = (pathname: string): boolean =>
  matchPath(pathname, {
    path: WILDFIRE_PROGRESSION_MODEL_ROUTE_PATH,
    exact: true,
  }) !== null;

/**
 * Resets the router entity selection by pushing `/`.
 * No-op for wildfire progression model route.
 */
export const resetRouterEntitySelection = (history: History): void => {
  if (
    pathnameIsExactRouterEntityDrawerPath(history.location.pathname) &&
    !isWildfireProgressionModelPath(history.location.pathname)
  ) {
    history.push('/');
  }
};
